__turbopack_context__.v({
  "pageHeader": "styles-module-scss-module__cIIXBq__pageHeader",
  "thumbnail": "styles-module-scss-module__cIIXBq__thumbnail",
});
